var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16075_36822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0469 0C5.45578 0 0 5.36203 0 11.9531C0 18.5442 5.45578 24 12.0469 24C18.638 24 24 18.5442 24 11.9531C24 5.36203 18.638 0 12.0469 0ZM17.9634 15.8808C18.5119 16.4292 18.5119 17.3213 17.9634 17.8702C17.4192 18.4139 16.5272 18.4228 15.9741 17.8702L12.0469 13.9416L8.02547 17.8706C7.47703 18.4191 6.585 18.4191 6.03609 17.8706C5.48766 17.3222 5.48766 16.4302 6.03609 15.8812L9.96422 11.9531L6.03609 8.025C5.48766 7.47609 5.48766 6.58406 6.03609 6.03562C6.585 5.48719 7.47703 5.48719 8.02547 6.03562L12.0469 9.96469L15.9741 6.03562C16.5216 5.48812 17.4136 5.48625 17.9634 6.03562C18.5119 6.58406 18.5119 7.47609 17.9634 8.025L14.0353 11.9531L17.9634 15.8808Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16075_36822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5be7ced00a4d44d3b2c6f264186324b6.svg";
export { ForwardRef as ReactComponent };